/**
 * Nom de l'événement émis pour ouvrir la modal support depuis l'extérieur (ex. menu profil).
 */
export const SUPPORT_OPEN_EVENT = "support:open"
